import React from 'react';

const Shop = () => (
    <>
    <h1>Shop</h1>
    <p>
        UwU
    </p>
    <p>
        KONEKO-CHAN rEEEE
    </p>
    </>
);

export default Shop;